<div class="dropDownFieldDs__cont">
  <div class="dropDownFieldDs__field" [class.disabled]="isDisabled">
    <app-ds-input-text
      [isFailed]="fieldIsFailed"
      [isReadonly]="true"
      [failedType]="fieldFailedType"
      [failedMessage]="fieldFailedMessage"
      [placeholder]="fieldPlaceholder"
      [label]="fieldLabel"
      [value]="dropDownListSelected?.Title"
      [icon]="chevronFilledDown"
      [isDisabled]="isDisabled"
      [filled]="fieldIsFilled"
      [staticFilled]="fieldStaticFilled"
      (clickEvent)="selectFieldAction()">
    </app-ds-input-text>
  </div>
  @if (!isDisabled && showDropDownList) {
    <div class="dropDownFieldDs__list" [style.height.px]="height">
      <app-ds-drop-down-list
        [selectedBy]="dropDownListSelectedBy"
        [options]="dropDownListOptions"
        [selectedId]="dropDownListSelected?.Id"
        [searchInput]="dropDownListSearchInput"
        [searchInputPlaceholder]="dropDownListSearchInputPlaceholder"
        [infiniteScrollDisabled]="infiniteScrollDisabled"
        (selectEvent)="selectFieldListAction($event)"
        (click)="onListClick($event)"
        (searched)="searched($event)">
      </app-ds-drop-down-list>
    </div>
  }
</div>